/** @jsxImportSource @emotion/react */

import { FC, useRef, useState } from 'react'
import { InputField, InputFieldProps } from 'components/Input'
import { ConfirmationModal } from 'components/Modals/ConfirmationModal/ConfirmationModal'
import * as classes from './styles'

const CLOSING_MODAL_DELAY = 200

export const SlugInputField: FC<InputFieldProps> = ({ onFocus, ...rest }) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isModalShown, setIsModalShown] = useState(false)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleConfirm = () => {
    handleCloseModal()
    setIsModalShown(true)
    setTimeout(() => {
      inputRef.current?.focus()
    }, CLOSING_MODAL_DELAY)
  }

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    if (!isModalShown) {
      handleOpenModal()
      e.target.blur()
    }
    onFocus?.(e)
  }

  return (
    <>
      <InputField onFocus={handleFocus} ref={inputRef} {...rest} />
      <ConfirmationModal
        open={isModalOpen && !isModalShown}
        css={classes.confirmationModal}
        title="Are you sure you want to change the slug?"
        subtitle="Changing the slug will affect the SEO of this page"
        onClose={handleCloseModal}
        onConfirm={handleConfirm}
        confirmText="Proceed with changes"
        closeText="Cancel"
      />
    </>
  )
}
